import memoizeOne from 'memoize-one';

export const getVersion = memoizeOne((pathname, latestVersion) => {
  const splitResult = pathname.split('/').filter(Boolean);
  let version = splitResult[0];
  if (version === 'component') {
    version = latestVersion;
  }
  return version;
});
